export default __webpack_public_path__ + "static/media/Documento Padrão.d43460d7.svg";